import { createAction, createAsyncAction } from "typesafe-actions";

import { MapEntity } from "@mapmycustomers/shared/types/entity";
import { MultiPin } from "@mapmycustomers/shared/types/map";
import RangeModel from "@mapmycustomers/shared/types/viewModel/internalModel/RangeModel";

import DownloadEntitiesMapping from "@app/types/DownloadEntitiesMapping";
import { AreaSearchQuery } from "@app/types/filters/AreaSearchQuery";
import MapRecordsListState from "@app/types/viewModel/MapRecordsListState";

export const showRouteMultiPinRecords = createAsyncAction(
  "route/routeDetails/showMultiPinRecords/request",
  "route/routeDetails/showMultiPinRecords/success",
  "route/routeDetails/showMultiPinRecords/failure"
)<MultiPin, { address?: string }, unknown>();

export const hideRouteMultiPin = createAction("route/routeDetails/hideMultiPin")();

export const fetchRouteMultiPinRecords = createAsyncAction(
  "route/routeDetails/fetchMultiPinRecords/request",
  "route/routeDetails/fetchMultiPinRecords/success",
  "route/routeDetails/fetchMultiPinRecords/failure"
)<{ range?: RangeModel; search?: string }, { count: number; records: MapEntity[] }, unknown>();

export const applyRouteRecordsListSettings = createAction(
  "route/routeDetails/applyRecordsListSettings"
)<Partial<MapRecordsListState>>();

export const updateRouteRecordsListCustomization = createAsyncAction(
  "route/routeDetails/updateRecordsListCustomization/request",
  "route/routeDetails/updateRecordsListCustomization/success",
  "route/routeDetails/updateRecordsListCustomization/failure"
)<MapRecordsListState, void, void>();

export const setRouteListViewLocationSortQuery = createAction(
  "route/routeDetails/setListViewLocationSortQuery"
)<AreaSearchQuery>();

export const downloadRouteMultiPinRecords = createAction(
  "route/routeDetails/downloadMultiPinRecords"
)<DownloadEntitiesMapping>();
